<footer class="text-center text-white bg-slate-400">
	<div class="justify-between items-start mx-auto max-w-screen-xl p-6 mXXXx-32">

		<input on:click type="button" value="Impressum" class="inline-block mb-4 px-6 py-2.5 bg-slate-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-slate-700 hover:shadow-lg focus:bg-slate-700 focus:shadow-lg  focus:outline-none focus:ring-0 active:bg-slate-800 active:shadow-lg transition duration-150 ease-in-out mr-1.5" data-bs-toggle="offcanvas" aria-controls="offcanvasRight"/>
		<br />
		<span>Diese Webseite verwendet keine Cookies.</span>

	</div>
</footer>
